'use strict';
angular.module("iconoglobe")
    .controller('MainCtrl', ['$scope', "$rootScope", "$state", "$http", "localStorageService", "$location", "$timeout", "$uibModal", "UserLocation", "toastService", "APP_VERSION", "$sce", "$translate", 'MetaUtilService', 'metaHelper', function ($scope, $rootScope, $state, $http, localStorageService, $location, $timeout, $uibModal, UserLocation, toastService, APP_VERSION, $sce, $translate, metadatautil, metaHelper) {
       // traceLog("tn-siteload", "MainCtrl-> started loading");
        // one time binding scopes
  $rootScope.storageHost = "https://iconoglobe.com";
$rootScope.imageBaseUrl = $rootScope.storageHost + "/i-i/";
$rootScope.thumbBaseUrl = $rootScope.imageBaseUrl + "/i-i/";
$rootScope.audioBaseUrl = $rootScope.storageHost + "/i-a/";
$rootScope.videoBaseUrl = $rootScope.storageHost + "/i-v/";
$rootScope.userProfile = $rootScope.imageBaseUrl;
$rootScope.userIcon = $rootScope.imageBaseUrl;
$rootScope.bannerBig = $rootScope.storageHost + "/i-i/";
$rootScope.bannerSmall = $rootScope.storageHost + "/i-i/";
$rootScope.genreBaseUrl = $rootScope.storageHost + "/i-i/genres/";
$rootScope.appImageBaseUrl = $rootScope.storageHost + "/i-i/";

// <- UPDATED
$rootScope.uploadedImageBase = $rootScope.storageHost + "/i-i/";

$rootScope.serverBannerBig = "/uploads/i-i/";
$rootScope.serverBannerSmall = "/uploads/i-i/";
$rootScope.serverAudioBaseUrl = "/uploads/i-a/";
$rootScope.serverVideoBaseUrl = "/uploads/i-v/";
$rootScope.serverUserProfile = "/uploads/i-i/";
$rootScope.serverImageBaseUrl = "/uploads/i-i/";
$rootScope.serverUserIcon = "/uploads/i-i/";

        
	setTimeout(function () {
    window.prerenderReady = true;
}, 500);	



		
		
		
		$scope.pageLoaded = function(){
           // traceLog("tn-siteload", "********************* PAGE LOADED **************************")
            if(!window.homePageVisited){
              //  traceLog("tn-siteload", "** this is not home page ** ")
                angular.element('#app-body').css('visibility', 'visible');
                angular.element('#app-body').css('overflow', 'hidden');
                angular.element('.intro-wrapper').hide();
            }
			
			
        }

        $scope.reloadHomePage = function(){
            $scope.$broadcast('reloadHomePage');
        }

        $rootScope.appVersion = APP_VERSION.version;
        $translate('views.logout').then(function (translation) {
            $rootScope.translation = {
                PleaseRegisteryourEnter: $translate.instant('views.PleaseRegisteryourEnter'),
                RegisterNow: $translate.instant('views.RegisterNow'),
                iconoglobeBeta: $translate.instant('views.iconoglobeBeta'),
                logout: $translate.instant('views.logout'),
                Sign_In: $translate.instant('views.Sign_In'),
                Sign_Up: $translate.instant('views.Sign_Up'),
                primary_profile: $translate.instant('views.primary_profile'),
                manage_profile: $translate.instant('views.manage_profile'),
                YourWorld: $translate.instant('views.YourWorld'),
                contactus: $translate.instant('views.contactus'),
                Careers: $translate.instant('views.Careers'),
                IndividualUserSupport: $translate.instant('views.IndividualUserSupport'),
                BusinessSupport: $translate.instant('views.BusinessSupport'),
                Abouticonoglobe: $translate.instant('views.Abouticonoglobe'),
                Press: $translate.instant('views.Press'),
                TermsofUse: $translate.instant('views.TermsofUse'),
                PrivacyPolicy: $translate.instant('views.PrivacyPolicy'),
                SiteMap: $translate.instant('views.SiteMap'),
                ClaimYourProfile: $translate.instant('views.ClaimYourProfile'),
				InvestWithUs: $translate.instant('views.InvestWithUs'),
                Advertiseoniconoglobe: $translate.instant('views.Advertiseoniconoglobe'),
                Live: $translate.instant('views.Live'),
                Life: $translate.instant('views.Life'),
                World: $translate.instant('views.World'),
                UpcomingEvents: $translate.instant('views.UpcomingEvents'),
                Welcome: $translate.instant('views.Welcome'),
                Manage: $translate.instant('views.Manage'),
                iconoglobeMobile: $translate.instant('views.iconoglobeMobile'),
                ContentGuideline: $translate.instant('views.ContentGuideline'),
                Backtotop: $translate.instant('views.Backtotop'),
                iconoglobeis: $translate.instant('views.iconoglobeis'),
                copyright: $translate.instant('views.copyright'),
                placeholderCity: $translate.instant('views.placeholderCity'),
                placeholderCountry: $translate.instant('views.placeholderCountry'),
                EnterValidCountry: $translate.instant('views.EnterValidCountry'),
                keyword: $translate.instant('views.keyword'),
                NoKeywordFound: $translate.instant('views.NoKeywordFound'),
                all_category: $translate.instant('views.all_category'),
                enterkeyword: $translate.instant('views.enterkeyword'),
                keyword_location: $translate.instant('views.keyword_location'),
                close_search: $translate.instant('views.close_search'),
                Category: $translate.instant('views.Category'),
                hide_cat: $translate.instant('views.hide_cat'),
                close_events: $translate.instant('views.close_events'),
                no_sub_category_found: $translate.instant('views.no_sub_category_found'),
                selectcategory: $translate.instant('views.selectcategory'),
                Close: $translate.instant('views.Close'),
                iconoman: $translate.instant('views.iconoman'),
                Adventures: $translate.instant('views.Adventures'),
                clickview: $translate.instant('views.clickview'),
                Festivals: $translate.instant('views.Festivals'),
                Gaming: $translate.instant('views.Gaming'),
                Museums: $translate.instant('views.Museums'),
                Music: $translate.instant('views.Music'),
                Nature: $translate.instant('views.Nature'),
                Sports: $translate.instant('views.Sports'),
                Childrens: $translate.instant('Childrens'),
                showonmap: $translate.instant('views.showonmap'),
                Address: $translate.instant('views.Address'),
                dateshrs: $translate.instant('views.dateshrs'),
                Phone: $translate.instant('views.phone'),
                email: $translate.instant('views.email'),
                homefooterText: $translate.instant('views.homefooterText'),
                Entertainment: $translate.instant('views.Entertainment'),
                Coming_Soon: $translate.instant('views.Coming Soon'),
                Photos: $translate.instant('views.Photos')
            };
            $rootScope.Countries = {
                New_Foundland: $translate.instant('views.Newfoundland'),
                Qatar: $translate.instant('views.Qatar'),
                Mozambique: $translate.instant('views.Mozambique'),
                Rwanda: $translate.instant('views.Rwanda'),
                Eritrea: $translate.instant('views.Eritrea'),
                Benin: $translate.instant('views.Benin'),
                Sierra_Leone: $translate.instant('views.Sierra Leone'),
                Macedonia: $translate.instant('views.Macedonia'),
                Poland: $translate.instant('views.Poland'),
                Jersey: $translate.instant('views.Jersey'),
                American_Samoa: $translate.instant('views.American Samoa'),
                Grenada: $translate.instant('views.Grenada'),
                Saint_Lucia: $translate.instant('views.Saint Lucia'),
                Saint_Barthelemy: $translate.instant('views.Saint Barthelemy'),
                Anguilla: $translate.instant('views.Anguilla'),
                Puerto_Rico: $translate.instant('views.Puerto Rico'),
                Bermuda: $translate.instant('views.Bermuda'),
                Tanzania: $translate.instant('views.Tanzania'),
                Burundi: $translate.instant('views.Burundi'),
                South_Sudan: $translate.instant('views.South Sudan'),
                Burkina_Faso: $translate.instant('views.Burkina Faso'),
                Guinea: $translate.instant('views.Guinea'),
                Greece: $translate.instant('views.Greece'),
                Belarus: $translate.instant('views.Belarus'),
                Guernsey: $translate.instant('views.Guernsey'),
                Barbados: $translate.instant('views.Barbados'),
                Faroe_Islands: $translate.instant('views.Faroe Islands'),
                doubletap: $translate.instant('views.doubletap'),
                Canada: $translate.instant('views.Canada'),
                Christmas_Island: $translate.instant('views.Christmas Island'),
                USA: $translate.instant('views.USA'),
                India: $translate.instant('views.India'),
                China: $translate.instant('views.China'),
                Russia: $translate.instant('views.Russia'),
                Greenland: $translate.instant('views.Greenland'),
                Iceland: $translate.instant('views.Iceland'),
                Marshall_Islands: $translate.instant('views.Marshall Islands'),
                Mexico: $translate.instant('views.Mexico'),
                Cuba: $translate.instant('views.Cuba'),
                Belize: $translate.instant('views.Belize'),
                Guatemala: $translate.instant('views.Guatemala'),
                Honduras: $translate.instant('views.Honduras'),
                El_Salvador: $translate.instant('views.El Salvador'),
                Australia: $translate.instant('views.Australia'),
                Nicaragua: $translate.instant('views.Nicaragua'),
                Costa_Rica: $translate.instant('views.Costa Rica'),
                Panama: $translate.instant('views.Panama'),
                Bahamas: $translate.instant('views.Bahamas'),
                Cayman_Islands: $translate.instant('views.Cayman Islands'),
                Jamaica: $translate.instant('views.Jamaica'),
                Haiti: $translate.instant('views.Haiti'),
                Dominican_Republic: $translate.instant('views.Dominican Republic'),
                Saint_Martin: $translate.instant('views.Saint Martin'),
                Indonesia: $translate.instant('views.Indonesia'),
                Montserrat: $translate.instant('views.Montserrat'),
                Guadeloupe: $translate.instant('views.Guadeloupe'),
                Dominica: $translate.instant('views.Dominica'),
                Martinique: $translate.instant('views.Martinique'),
                Aruba: $translate.instant('views.Aruba'),
                Curacao: $translate.instant('views.Curacao'),
                Caribbean_Netherlands: $translate.instant('views.Caribbean Netherlands'),
                Venezuela: $translate.instant('views.Venezuela'),
                Colombia: $translate.instant('views.Colombia'),
                Guyana: $translate.instant('views.Guyana'),
                Suriname: $translate.instant('views.Suriname'),
                French_Guiana: $translate.instant('views.French Guiana'),
                Ecuador: $translate.instant('views.Ecuador'),
                Peru: $translate.instant('views.Peru'),
                Brazil: $translate.instant('views.Brazil'),
                Bolivia: $translate.instant('views.Bolivia'),
                Paraguay: $translate.instant('views.Paraguay'),
                Argentina: $translate.instant('views.Argentina'),
                Uruguay: $translate.instant('views.Uruguay'),
                Chile: $translate.instant('views.Chile'),
                Falkland_Islands: $translate.instant('views.Falkland Islands'),
                Hawaii: $translate.instant('views.Hawaii'),
                Kiribati: $translate.instant('views.Kiribati'),
                French_Polynesia: $translate.instant('views.French Polynesia'),
                Cook_Islands: $translate.instant('views.Cook Islands'),
                Pitcairn_Islands: $translate.instant('views.Pitcairn Islands'),
                Norway: $translate.instant('views.Norway'),
                Finland: $translate.instant('views.Finland'),
                Sweden: $translate.instant('views.Sweden'),
                Estonia: $translate.instant('views.Estonia'),
                Latvia: $translate.instant('views.Latvia'),
                Lithuania: $translate.instant('views.Lithuania'),
                Denmark: $translate.instant('views.Denmark'),
                Aland_Islands: $translate.instant('views.Aland Islands'),
                United_Kingdom: $translate.instant('views.United Kingdom'),
                Ireland: $translate.instant('views.Ireland'),
                Ukraine: $translate.instant('views.Ukraine'),
                Moldova: $translate.instant('views.Moldova'),
                Romania: $translate.instant('views.Romania'),
                Slovakia: $translate.instant('views.Slovakia'),
                Czech_Republic: $translate.instant('views.Czech Republic'),
                Germany: $translate.instant('views.Germany'),
                Netherlands: $translate.instant('views.Netherlands'),
                Belgium: $translate.instant('views.Belgium'),
                Luxembourg: $translate.instant('views.Luxembourg'),
                France: $translate.instant('views.France'),
                Austria: $translate.instant('views.Austria'),
                Liechtenstein: $translate.instant('views.Liechtenstein'),
                Switzerland: $translate.instant('views.Switzerland'),
                Hungary: $translate.instant('views.Hungary'),
                Bulgaria: $translate.instant('views.Bulgaria'),
                Serbia: $translate.instant('views.Serbia'),
                Slovenia: $translate.instant('views.Slovenia'),
                Croatia: $translate.instant('views.Croatia'),
                Albania: $translate.instant('views.Albania'),
                Kosovo: $translate.instant('views.Kosovo'),
                Montenegro: $translate.instant('views.Montenegro'),
                Italy: $translate.instant('views.Italy'),
                Monaco: $translate.instant('views.Monaco'),
                Andorra: $translate.instant('views.Andorra'),
                Spain: $translate.instant('views.Spain'),
                Portugal: $translate.instant('views.Portugal'),
                Gibraltar: $translate.instant('views.Gibraltar'),
                Malta: $translate.instant('views.Malta'),
                Turkey: $translate.instant('views.Turkey'),
				Türkiye: $translate.instant('views.Turkey'),
                Cyprus: $translate.instant('views.Cyprus'),
                Tunisia: $translate.instant('views.Tunisia'),
                Algeria: $translate.instant('views.Algeria'),
                Morocco: $translate.instant('views.Morocco'),
                Western_Sahara: $translate.instant('views.Western Sahara'),
                Libya: $translate.instant('views.Libya'),
                Egypt: $translate.instant('views.Egypt'),
                Sudan: $translate.instant('views.Sudan'),
                Chad: $translate.instant('views.Chad'),
                Niger: $translate.instant('views.Niger'),
                Mali: $translate.instant('views.Mali'),
                Mauritania: $translate.instant('views.Mauritania'),
                Senegal: $translate.instant('views.Senegal'),
                Gambia: $translate.instant('views.Gambia'),
                Liberia: $translate.instant('views.Liberia'),
                Togo: $translate.instant('views.Togo'),
                Ghana: $translate.instant('views.Ghana'),
                Nigeria: $translate.instant('views.Nigeria'),
                Cameroon: $translate.instant('views.Cameroon'),
                Djibouti: $translate.instant('views.Djibouti'),
                Ethiopia: $translate.instant('views.Ethiopia'),
                Somalia: $translate.instant('views.Somalia'),
                Kenya: $translate.instant('views.Kenya'),
                Uganda: $translate.instant('views.Uganda'),
                Congo: $translate.instant('views.Congo'),
                Gabon: $translate.instant('views.Gabon'),
                Equatorial_Guinea: $translate.instant('views.Equatorial Guinea'),
                Angola: $translate.instant('views.Angola'),
                Malawi: $translate.instant('views.Malawi'),
                Zambia: $translate.instant('views.Zambia'),
                Zimbabwe: $translate.instant('views.Zimbabwe'),
                Botswana: $translate.instant('views.Botswana'),
                Namibia: $translate.instant('views.Namibia'),
                Lesotho: $translate.instant('views.Lesotho'),
                South_Africa: $translate.instant('views.South Africa'),
                Eswatini: $translate.instant('views.Eswatini'),
                Canary_Islands: $translate.instant('views.Canary Islands'),
                Cape_Verde: $translate.instant('views.Cape Verde'),
                Saint_Helena: $translate.instant('views.Saint Helena'),
                Reunion: $translate.instant('views.Reunion'),
                Mauritius: $translate.instant('views.Mauritius'),
                Madagascar: $translate.instant('views.Madagascar'),
                Mayotte: $translate.instant('views.Mayotte'),
                Comoros: $translate.instant('views.Comoros'),
                Seychelles: $translate.instant('views.Seychelles'),
                Maldives: $translate.instant('views.Maldives'),
                Lakshadweep: $translate.instant('views.Lakshadweep'),
                Sri_Lanka: $translate.instant('views.Sri Lanka'),
                Oman: $translate.instant('views.Oman'),
                Yemen: $translate.instant('views.Yemen'),
                Saudi_Arabia: $translate.instant('views.Saudi Arabia'),
                Bahrain: $translate.instant('views.Bahrain'),
                Kuwait: $translate.instant('views.Kuwait'),
                Iraq: $translate.instant('views.Iraq'),
                Jordan: $translate.instant('views.Jordan'),
                Israel: $translate.instant('views.Israel'),
                Palestine: $translate.instant('views.Palestine'),
                Lebanon: $translate.instant('views.Lebanon'),
                Syria: $translate.instant('views.Syria'),
                Georgia: $translate.instant('views.Georgia'),
                Armenia: $translate.instant('views.Armenia'),
                Azerbaijan: $translate.instant('views.Azerbaijan'),
                Pakistan: $translate.instant('views.Pakistan'),
                Iran: $translate.instant('views.Iran'),
                Afghanistan: $translate.instant('views.Afghanistan'),
                Tajikistan: $translate.instant('views.Tajikistan'),
                Turkmenistan: $translate.instant('views.Turkmenistan'),
                Kyrgyzstan: $translate.instant('views.Kyrgyzstan'),
                Uzbekistan: $translate.instant('views.Uzbekistan'),
                Kazakhstan: $translate.instant('views.Kazakhstan'),
                Mongolia: $translate.instant('views.Mongolia'),
                Japan: $translate.instant('views.Japan'),
                North_Korea: $translate.instant('views.North Korea'),
                South_Korea: $translate.instant('views.South Korea'),
                Taiwan: $translate.instant('views.Taiwan'),
                Hainan: $translate.instant('views.Hainan'),
                Vietnam: $translate.instant('views.Vietnam'),
                Laos: $translate.instant('views.Laos'),
                Cambodia: $translate.instant('views.Cambodia'),
                Thailand: $translate.instant('views.Thailand'),
                Myanmar: $translate.instant('views.Myanmar'),
                Bhutan: $translate.instant('views.Bhutan'),
                Nepal: $translate.instant('views.Nepal'),
                Bangladesh: $translate.instant('views.Bangladesh'),
                Philippines: $translate.instant('views.Philippines'),
                Malaysia: $translate.instant('views.Malaysia'),
                Brunei: $translate.instant('views.Brunei'),
                Palau: $translate.instant('views.Palau'),
                Guam: $translate.instant('views.Guam'),
                Nauru: $translate.instant('views.Nauru'),
                Timor_leste: $translate.instant('views.Timor leste'),
                New_Zealand: $translate.instant('views.New Zealand'),
                Solomon_Islands: $translate.instant('views.Solomon Islands'),
                Norfolk_Island: $translate.instant('views.Norfolk Island'),
                New_Caledonia: $translate.instant('views.New Caledonia'),
                Vanuatu: $translate.instant('views.Vanuatu'),
                Niue: $translate.instant('views.Niue'),
                Fiji_Islands: $translate.instant('views.Fiji Islands'),
                Fiji : $translate.instant('views.Fiji Islands'),
                Tonga: $translate.instant('views.Tonga'),
                Tuvalu: $translate.instant('views.Tuvalu'),
                Tokelau: $translate.instant('views.Tokelau'),
                Micronesia: $translate.instant('views.Micronesia'),
                Singapore: $translate.instant('views.Singapore'),
                Hong_Kong: $translate.instant('views.Hong Kong'),
                Macau: $translate.instant('views.Macau'),
                Alaska: $translate.instant('views.Alaska'),
                slide: $translate.instant('views.slide'),
                Svalbard_and_Jan_Mayen: $translate.instant('views.Svalbard and Jan Mayen'),
                Turks_and_Caicos_Islands: $translate.instant('views.Turks and Caicos Islands'),
                British_Virgin_Islands: $translate.instant('views.British Virgin Islands'),
                U_S_Virgin_Islands: $translate.instant('views.U S Virgin Islands'),
                Saint_Kitts_and_Nevis: $translate.instant('views.Saint Kitts and Nevis'),
                Antigua_and_Barbuda: $translate.instant('views.Antigua and Barbuda'),
                Saint_Vincent_and_the_Grenadin: $translate.instant('views.Saint Vincent and the Grenadin'),
                Trinidad_and_Tobago: $translate.instant('views.Trinidad and Tobago'),
                Isle_of_Man: $translate.instant('views.Isle of Man'),
                Saint_Pierre_and_Miquelon: $translate.instant('views.Saint Pierre and Miquelon'),
                Bosnia_and_Herzegovina: $translate.instant('views.Bosnia and Herzegovina'),
                Guinea_Bissau: $translate.instant('views.Guinea-Bissau'),
                Cote_d_Ivoire: $translate.instant('views.Cote d Ivoire'),
                Central_African_Republic: $translate.instant('views.Central African Republic'),
                Democratic_Republic_of_Congo: $translate.instant('views.Democratic Republic of Congo'),
                Sao_Tome_and_Principe: $translate.instant('views.Sao Tome and Principe'),
                United_Arab_Emirates: $translate.instant('views.United Arab Emirates'),
                British_Indian_Ocean_Territory: $translate.instant('views.British Indian Ocean Territory'),
                Cocos_Keeling_Islands: $translate.instant('views.Cocos Keeling Islands'),
                Northern_Mariana_Islands: $translate.instant('views.Northern Mariana Islands'),
                Papua_New_Guinea: $translate.instant('views.Papua New Guinea'),
                Wallis_and_Futuna: $translate.instant('views.Wallis and Futuna'),
                eaustralia: $translate.instant("views.eaustralia"),
                waustralia: $translate.instant("views.waustralia"),
                nwaustralia: $translate.instant("views.nwaustralia"),
                seaustralia: $translate.instant("views.seaustralia"),
                neaustralia: $translate.instant("views.neaustralia"),
                naustralia: $translate.instant("views.naustralia"),
                swaustralia: $translate.instant("views.swaustralia"),
                tasmania: $translate.instant("views.tasmania"),
                eindonesia: $translate.instant("views.eindonesia"),
                windonesia: $translate.instant("views.windonesia"),
                cindonesia: $translate.instant("views.cindonesia"),
                serussia: $translate.instant("views.serussia"),
                nbrazil: $translate.instant("views.nbrazil"),
                sbrazil: $translate.instant("views.sbrazil"),
                nwbrazil: $translate.instant("views.nwbrazil"),
                vaticancity: $translate.instant("views.vaticancity"),
                sanmarino: $translate.instant("views.sanmarino"),
                nwrussia: $translate.instant("views.nwrussia"),
                smexico: $translate.instant("views.smexico"),
                nmexico: $translate.instant("views.nmexico"),
                nwmexico: $translate.instant("views.nwmexico"),
                Samoa: $translate.instant('views.Western Samoa'),
                Nova_Scotia: $translate.instant('views.Nova Scotia'),
                Prince_Edward_Island: $translate.instant('views.Prince Edward Island'),
                Andaman_and_Nicobar: $translate.instant('views.Andaman and Nicobar Islands'),
            };
        });
        // one time binding scopes
metadatautil.metaInformation({
    pageTitle: "iconoglobe - Streaming the World's ICONs!",
    metaDescription: "iconoglobe - Discover the World's Live Streams",
    metaKeywords: "iconoglobe louisP, louišP Inc.",
    metaOgImage: "ogiconoglobe.png"
});
    
        var currentPath = $location.path();
        var path = currentPath.split("/");
	 
        if (path[3] == 'valid') {
            $http.post('/api/checkrandomnumber', {
                rand_id: currentPath
            }).then(function (res) {
			//	console.log("pathres###############",res);
                var data = res.data;
                if (data == 1) {
					$timeout(function () {
                        angular.element('.verifiedmsg').removeClass('hide');
                    }, 1000);
					
                    $location.path("/");
                } else if (data == 2) {
                    $timeout(function () {
                        angular.element('.wrongmailmsg').removeClass('hide');
                    }, 1000);
                    $location.path('/');
                } else if (data == 3) {
                    $timeout(function () {
                        angular.element('.alreadymsg').removeClass('hide');
                    }, 1000);
                    $location.path('/');
                }
            });
        }
		if (path[3] == 'investvalid') {
            $http.post('/api/checkinvest', {
                rand_id: currentPath
            }).then(function (res) {
                var data = res.data;
                if (data == 1) {
                    $location.path("/profile");
                } else if (data == 2) {
                    $timeout(function () {
                        angular.element('.wrongmailmsg').removeClass('hide');
                    }, 1000);
                    $location.path('/login');
                } else if (data == 3) {
                    $timeout(function () {
                        angular.element('.alreadymsg').removeClass('hide');
                    }, 1000);
                    $location.path('/login');
                }
            });
        }
        if (path[1] == 'resetpassword') {
            $http.post('/api/checkresetlink', {
                id: path[2]
            }).then(function (res) {
                var data = res.data;
                if (data.status == 1) {
                    var message = $filter('translate')("views.linkexpired");
                    toastService.create(message, 'down', 'default', 3000);
                    $location.path('/login');
                } else {
                    $location.path('/resetpassword/' + path[2] + '/' + path[3]);
                }
            });
        }
        $scope.iconoModal = function (type) {
            $scope.modalInstance = $uibModal.open({
                animation: true,
                templateUrl: type + '_modal.html',
                windowClass: 'zindexModal int40',
                scope: $scope,
            });
            $scope.modalInstance.result.then(function (selectedItem) {
                $scope.closeModal();
            }, function () {
                $scope.closeModal();
            });
        };
        $scope.closeModal = function () {
            $scope.modalInstance.dismiss();
        };
        if (!isMobile) {
            $(window).scroll(function () {
                if ($(window).scrollTop() > $('.topbar').height() + 90) {
                    $('body').addClass('isScroll');
                } else {
                    $('body').removeClass('isScroll');
                }
            });
        }
        $scope.goto = function (url) {
            $location.path(url);
        };
        $scope.logout = function () {
            $http.get('/api/logout').then(function (res) {
                localStorageService.remove('name');
                localStorageService.remove('usercat');
                $rootScope.loggedusername = null;
                $location.path("/");
            }, function (err) {
            });
        };
        $scope.geoTracker = function () {
            var currStateName = $state.$current.name;
            UserLocation.getLocation().then(function (user) {
                if (currStateName == "maps.world") {
                    $location.search({
                        "at": user.long + "," + user.lat,
                    });
                    localStorageService.set('city_lat', user.lat);
                    localStorageService.set('city_lng', user.long);
                    var zoom = 12;
                    // if(window.innerWidth < 801){
                    //   zoom = 11;
                    // }
                    var coor = {
                        latitude: user.lat,
                        longitude: user.long,
                        zoom: zoom
                    };
                    $scope.$broadcast('loadLocationMap', coor);
                } else {
                    localStorageService.set('geo_search', 1);
                    $location.path('/').search({
                        "at": user.long + "," + user.lat,
                    });
                }
            });
        };
        $scope.gotoWorld = function () {
            if (localStorageService.get('name') == null) {
                $location.path("/login");
            } else {
                $location.path("/profile");
            }
        };
        $scope.toggleMobileMenu = function () {
            $(".nav-icon").toggleClass('open');
            $('.serg-popup-menu-wrap').toggleClass('active');
			$('body#body').css('overflow-y', 'scroll');
			$('.event_catergory_slider').toggleClass('hide');
			angular.element('#eeslct').removeClass('eeexp');
        };
	 $scope.toggleCardMenu = function () {
            $(".card-icon").toggleClass('open');
            $('.card-menu-wrap').toggleClass('active');
        };
         $scope.toggleMobileMenu2 = function () {
            $(".nav2-icon2").toggleClass('open');
            $('.serg-popup-menu-wrap2').toggleClass('active');
        };
	    $scope.toggleMobileMenu3 = function () {
            $(".nav3-icon3").toggleClass('open');
            $('.serg-popup-menu-wrap3').toggleClass('active');
        };
        /**
         * intro page images
         */
        $scope.mainlogo = "main-logo";
        $scope.region = '';
        /**
         * Change images
         * @on the basis on region
         */
        var siteBaseUrl = window.location.host;
        // siteBaseUrl = "iconoglobe.cn";
        if (siteBaseUrl.indexOf("iconoglobe.cn") > -1) {
            $scope.region = 'chinaaccess';
            $scope.mainlogo = "china-main-logo";
        }
        $scope.showEvents = function () {
            $scope.$broadcast('getUpcomingEvents');
        };
        $scope.backToTop = function () {
            $('body,html').animate({
                scrollTop: 0
            }, 'fast');
        };
        $scope.isiOS = function () {
            var iDevices = [
                'iPad Simulator',
                'iPad'
            ];
            if (!!navigator.platform) {
                while (iDevices.length) {
                    if (navigator.platform === iDevices.pop()) {
                        return true;
                    }
                }
            }
            return false;
        };
        $scope.isiPhone = function () {
            var iDevices = [
                'iPhone Simulator',
                'iPod Simulator',
                'iPhone',
                'iPod'
            ];
            if (!!navigator.platform) {
                while (iDevices.length) {
                    if (navigator.platform === iDevices.pop()) {
                        return true;
                    }
                }
            }
            return false;
        };
        $scope.iOS = $scope.isiOS() ? 'apple-touch' : '';
        $scope.iPhone = $scope.isiPhone() ? 'apple-phone' : '';
        $scope.checkiPhone = $scope.isiPhone();
       if (!$rootScope.isSharedView) {
         metaHelper.setMeta();
         } else {
    //console.log("MainCtrl: metaHelper skipped (shared view)");
}
        
        
        
        
        
        $rootScope.loginuser = function (valid) {
		//	console.log("mainlogintrue",valid);
            $scope.submitted = true;
            if (valid == true) {
                $http.post('/api/login', {login: this.loginData})
                    .then(function (res) {
                        var data = res.data;
                        if (data.status == 3 || data.status == 4 || data.status == 5 || data.status == 6) {
                        } else {
                            $http.get('/api/isloggedin').then(function (res) {
                                var data = res.data;
                                $rootScope.user = res.data;
                                if (data.user != 1) {
                                    if (data.status == 1) {
                                        localStorageService.set('name', data.name);
                                        localStorageService.set('usercategory', data.usercategory);
                                        $rootScope.usercategory = data.usercategory;
                                        $rootScope.loggedusername = data.name;
                                        $("#topmenu").css('display', 'block');
                                    } else {
                                        localStorageService.remove('name');
                                    }
                                } else {
                                    angular.element('.login').addClass('hide');
                                    angular.element('.signinup').removeClass('hide');
                                    localStorageService.remove('name');
                                }
                            }, function (err) {
                             console.log(err);
                            });
                        }
                    }, function (err) {
                    });
            }
        };
        $scope.hideIntroPage = function () {
            angular.element('.main-intro').addClass('slide-over');
            setTimeout(function () {
                angular.element('#app-body').css('visibility', 'visible');
                angular.element('#app-body').css('overflow', 'hidden');
                angular.element('.intro-wrapper').remove();
            }, 600);
            return true;
        };
        $scope.isLoggedInCheck = function () {
            if (!localStorageService.get('name')) {
                $scope.modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'sign_in_modal.html',
                    windowClass: 'zindexModal int41',
                    scope: $scope,
                });
                $scope.modalInstance.result.then(function (selectedItem) {
                    $scope.closeModal();
                }, function () {
                    $scope.closeModal();
                });
            } else {
                angular.element("#upload_esta_photo").click();
            }
        };
		angular.element("#body").css("opacity", "1");
      //  traceLog("tn-siteload", "MainCtrl-> ended loading");
    }]);
